<template>
	<div class="content-wrapper">
		<div class="flex-100">
			<div class="flex-1 border-bottom">
				<div class="d-flex justify-content-center align-items-center w-100" style="height: calc(100vh - 200px)">
					<div class="d-block text-center">
						<span class="spinner-border m-0 f-c-blue"
						      role="status"
						      aria-hidden="true"
						      style="height: 48px; width: 48px;"
						>
						</span>
						<div class="f-bold f-16 f-c-black m-t-8">
							Sedang mengekspor data...
						</div>
						<div class="f-regular f-13 f-c-midgrey" v-if="exportData.total !== 0">
							{{ exportData.processed }} dari {{ exportData.total }} data
						</div>
						<div class="f-regular f-13 f-c-midgrey" v-else>
							Memproses ekspor...
						</div>
					</div>
				</div>

			</div>

			<div class="d-block text-center p-x-20 p-y-20">
				<div class="f-regular f-13 f-c-midgrey p-d-12">
					Anda dapat meninggalkan jendela ini dan menjalankan prosesnya di latar belakang.
				</div>
				<SOButton
					:text="'Jalankan di latar belakang'"
					:outline="true"
					@action="minimized"
				/>
			</div>
		</div>
	</div>
</template>

<script>
import SOButton from "@/so-components/global/ui/SOButton";

export default {
	name: "SOImportProgress",
	components: {
		SOButton
	},
	props: {
		context: String,
		trackerActions: String,
		deleteActions: String,
	},
	mounted() {
		this.runTrackerV2()
	},
	data() {
		return {
			percent: "0",
			looper: null,
			delay: 5000,

			exportData: {
				processed: 0,
				total: 0,
				mulitpeExportData: []
			},
		}
	},
	methods: {
		runTracker() {
			this.looper = setInterval(async () => {
				await this.tracker()
			}, this.delay);
		},
		runTrackerV2() {
			$("#nav-bottom").hide()

			this.looper = setInterval(async () => {
				await this.trackerV2()
			}, this.delay);
		},
		async tracker() {
			const res = await this.$store.dispatch(this.trackerActions)
			if (res.success) {
				// let progress = (parseFloat(res.data.progress_looping) / parseFloat(res.data.length_data)) * 100
				// this.percent = progress.toFixed(2).replace(".", ",")
				this.exportData.processed = res.data.progress_looping
				this.exportData.total = res.data.length_data

				switch (res.data.status_progress) {
					case "0": // onprogress
						break;
					case "1": // berhasil
						clearInterval(this.looper)
						this.$toast.success("Data " + this.context + " sukses di ekspor")

						this.downloadFile(res.data)
						this.$emit("on-success")
						$("#nav-bottom").show()
						break;
					case "2": // error
						clearInterval(this.looper)
						this.$toast.error(res.data.msg_progress)

						this.$emit("on-error", res.data)
						$("#nav-bottom").show()
						break;
					case "3": // tidak ada progress
						clearInterval(this.looper)
						// this.$toast.error(res.data.msg_progress)

						this.$emit("on-success")
						$("#nav-bottom").show()
						break;
					default:
						clearInterval(this.looper)
						this.$toast.error(res.data.msg_progress)

						this.$emit("on-error", res.data)
						$("#nav-bottom").show()
						break;
				}
			} else {
				clearInterval(this.looper)
				this.$toast.error(res.err)

				this.$emit("on-error", res.data)
				$("#nav-bottom").show()
			}
		},
		async trackerV2() {
			const res = await this.$store.dispatch(this.trackerActions)
			if (res.success) {
				if (res.data === null) {
					clearInterval(this.looper)
					this.$toast.error(res.msg)
					this.statusTracker = 2
					return
				}

				this.exportData.total = res.data.length
				this.exportData.processed = res.data.progress
				this.exportData.mulitpeExportData = res.data.info_data_export

				switch (res.data.status) {
					case 0: // onprogress
						break;
					case 1: // berhasil
						clearInterval(this.looper)
						this.$toast.success("Data " + this.context + " sukses di ekspor")

						this.$emit("on-success")
						$("#nav-bottom").show()
						break;
					case 2: // error
						clearInterval(this.looper)
						this.$toast.error(res.data.error_message)

						this.$emit("on-error", res.data)
						$("#nav-bottom").show()
						break;
					case 3: // tidak ada progress
						clearInterval(this.looper)
						// this.$toast.error(res.data.msg_progress)

						this.$emit("on-success")
						$("#nav-bottom").show()
						break;
					default:
						clearInterval(this.looper)
						this.$toast.error(res.data.msg_progress)

						this.$emit("on-error", res.data)
						$("#nav-bottom").show()
						break;
				}

				// let successCount = 0;
				//
				// for (let i = 0; i < this.exportData.mulitpeExportData.length; i++) {
				// 	switch (this.exportData.mulitpeExportData[i].status) {
				// 		case 0: // onprogress
				// 			break;
				// 		case 1: // berhasil
				// 			successCount += 1;
				// 			break;
				// 		case 2: // error
				// 			clearInterval(this.looper)
				// 			this.$toast.error(res.data.msg_progress)
				//
				// 			this.$emit("on-error", res.data)
				// 			break;
				// 		case 3: // tidak ada progress
				// 			clearInterval(this.looper)
				// 			// this.$toast.error(res.data.msg_progress)
				//
				// 			this.$emit("on-success")
				// 			break;
				// 		default:
				// 			clearInterval(this.looper)
				// 			this.$toast.error(res.data.msg_progress)
				//
				// 			this.$emit("on-error", res.data)
				// 			break;
				// 	}
				//
				// 	// export progress
				// 	this.exportData.processed = 0
				// 	this.exportData.total = this.exportData.total + this.exportData.mulitpeExportData[i].progress
				// }
				//
				// if (this.exportData.mulitpeExportData.length === successCount) {
				// 	clearInterval(this.looper)
				// 	this.$toast.success("Data " + this.context + " sukses di ekspor")
				//
				// 	this.$emit("on-success")
				// }
			} else {
				clearInterval(this.looper)
				this.$toast.error(res.err)

				this.$emit("on-error", res.data)
				$("#nav-bottom").show()
			}
		},
		downloadFile(data) {
			window.open(data.link_url, '_blank');
			setTimeout(() => {
				this.deleteFileExport(data.filename)
			}, 5000)
		},
		async deleteFileExport(filename) {
			const res = await this.$store.dispatch(this.deleteActions, filename)
		},
		minimized() {
			clearInterval(this.looper)
			this.$emit("minimized-export", this.exportData)
			$("#nav-bottom").show()
		}
	}
}
</script>